import useAutosaveController from 'hooks/useAutosaveController';
import { useCallback } from 'react';

const ASSIGNMENT_AUTOSAVE_DELAY = 800;

const useAssignmentAutosave = ({
    enabled,
    autoSaveEnabled = enabled,
    form,
    initialLastSavedAt,
    isValid = true,
    onInvalidSave,
    persist,
    getSavedAt,
}) => {
    const validate = useCallback(() => isValid, [isValid]);
    const controller = useAutosaveController({
        value: form,
        enabled,
        autoSaveEnabled,
        debounceMs: ASSIGNMENT_AUTOSAVE_DELAY,
        initialLastSavedAt,
        persist,
        validate,
        onInvalid: onInvalidSave,
        getSavedAt,
    });
    const {
        isDirty,
        lastSavedAt,
        markDirty,
        pause,
        reset: resetController,
        resume,
        save,
        status,
        waitForIdle,
    } = controller;
    const reset = useCallback(
        (next, timestamp) => resetController(next, { lastSavedAt: timestamp }),
        [resetController]
    );
    return { isDirty, lastSavedAt, markDirty, pause, reset, resume, save, status, waitForIdle };
};

export default useAssignmentAutosave;
